<template>
  <div :class="{
      'dashboard-toast': true,
      [`toast-${variant}`]: true
    }">
        <div class="toast-title">
            {{ $t('notification_toast.'+variant) }}

            <img src="/icons/toast-close.svg" @click="$emit('close')">
        </div>
        <p class="toast-text">
            {{ $t(`error_codes.${content}`) }}
        </p>
  </div>
</template>

<script>
export default {
    props: {
        title: String,
        variant: String,
        content: String
    },
    mounted() {
        setTimeout(() => {
            if (this) {
                this.$emit('close');
            }
        }, 15000);
    }
}
</script>

<style scoped>
.dashboard-toast {
    border-radius: 0.6vh;
    padding: 1.66vh;

    transition: 0.3s;

    margin-bottom: 1.65vh;

    min-width: 50vh;
    max-width: 50vh;

    box-shadow: 0 3px 7px rgba(0,0,0,0.25);
}

.dashboard-toast img {
    cursor: pointer;
}

.dashboard-toast p {
    margin: 0;
    padding: 0;
    font-size: 1.6vh;
}

.toast-title {
    font-size: 2.3vh;

    display: flex;
    justify-content: space-between;
    align-content: center;
    line-height: normal;
}

.toast-error {
    background: #ededed;
    color: #1d1d1b;
    border: 1px solid #e2223b;
}

.toast-confirm {
    background: #ededed;
    color: #1d1d1b;
    border: 1px solid #129b81;
}

.toast-info {
    background: #ededed;
    color: #1d1d1b;
    border: 1px solid #908f8d;
}
</style>